import {
  iconSuccess,
  iconInformational01,
  iconHighlight
} from '@bukalapak/bazaar-token'

export default {
  cashback: iconSuccess,
  discount: iconHighlight,
  'free-shipping': iconInformational01
}
